// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3-0 {\n  display: flex;\n}\n\n._3-1 {\n  flex-direction: row;\n}\n\n._3-2 {\n  flex-direction: column;\n}\n\n._3-3 {\n  flex-direction: row-reverse;\n}\n\n._3-4 {\n  flex-direction: column-reverse;\n}\n\n._3-5 {\n  align-items: center;\n}\n._3-6 {\n  align-items: flex-start;\n}\n._3-7 {\n  align-items: flex-end;\n}\n._3-8 {\n  align-items: stretch;\n}\n._3-9 {\n  align-items: baseline;\n}\n\n._3-a {\n  align-self: center;\n}\n._3-b {\n  align-self: flex-start;\n}\n._3-c {\n  align-self: flex-end;\n}\n._3-d {\n  align-self: stretch;\n}\n._3-e {\n  align-self: baseline;\n}\n\n._3-f {\n  justify-content: center;\n}\n._3-g {\n  justify-content: flex-start;\n}\n._3-h {\n  justify-content: flex-end;\n}\n._3-i {\n  justify-content: space-between;\n}\n._3-j {\n  justify-content: space-around;\n}\n._3-k {\n  justify-content: space-evenly;\n}\n\n._3-l {\n  flex-wrap: wrap;\n}\n\n._3-m {\n  flex-wrap: nowrap;\n}\n\n._3-n {\n  flex-wrap: wrap-reverse;\n}\n", ""]);
// Exports
export var flex = "_3-0";
export var row = "_3-1";
export var column = "_3-2";
export var rowReverse = "_3-3";
export var columnReverse = "_3-4";
export var alignCenter = "_3-5";
export var alignFlexStart = "_3-6";
export var alignFlexEnd = "_3-7";
export var alignStretch = "_3-8";
export var alignBaseline = "_3-9";
export var alignSelfCenter = "_3-a";
export var alignSelfFlexStart = "_3-b";
export var alignSelfFlexEnd = "_3-c";
export var alignSelfStretch = "_3-d";
export var alignSelfBaseline = "_3-e";
export var justifyCenter = "_3-f";
export var justifyFlexStart = "_3-g";
export var justifyFlexEnd = "_3-h";
export var justifySpaceBetween = "_3-i";
export var justifySpaceAround = "_3-j";
export var justifySpaceEvenly = "_3-k";
export var wrapWrap = "_3-l";
export var wrapNowrap = "_3-m";
export var wrapWrapReverse = "_3-n";
export default ___CSS_LOADER_EXPORT___;
